import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  padding: 1.2rem;
  border-radius: 1rem;
  background-color: ${({ theme }) => theme.colors.SECONDARY};
  // margin-bottom: 0.6rem;

  :hover {
    cursor: pointer;
    background-color: ${({ theme }) => theme.colors.PRIMARY};

    > p {
      color: ${({ theme }) => theme.colors.WHITE};
    }
    > h2 {
      color: ${({ theme }) => theme.colors.WHITE};
    }
  }

  @media only screen and (min-width: 768px) {
    max-width: 35.2rem;
    margin: 0 auto;
  }
`;

export const Titulo = styled.h2`
  font-size: 1.6rem;
  font-style: normal;
  font-weight: 700;
  line-height: 2rem;
  letter-spacing: 0em;
  text-align: left;

  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;

  color: ${({ theme }) => theme.colors.PRIMARY};
`;

export const Body = styled.p`
  font-size: 1.6rem;
  font-style: normal;
  font-weight: 400;
  line-height: 2rem;
  letter-spacing: 0em;
  text-align: left;

  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;

  color: ${({ theme }) => theme.colors.PRIMARY};
`;
